import { useMemo } from 'react';

import {
    checkRequiresPhoneVerification,
    checkRequiresPasswordVerification,
    checkRequiresPasswordProtection,
} from '@/components/utils';
import { Policy } from '@/types/types';

interface PolicyRequirements {
    requiresPhone: boolean;
    requiresPassword: boolean;
}

const usePolicyRequirements = (policy: Policy): PolicyRequirements =>
    useMemo(() => {
        if (!policy) return { requiresPhone: false, requiresPassword: false };
        return {
            requiresPhone: checkRequiresPhoneVerification(policy.settings),
            requiresPassword: checkRequiresPasswordVerification(policy.settings)
                || checkRequiresPasswordProtection(policy.settings),
        };
    }, [policy]);

export default usePolicyRequirements;
